module.exports = __webpack_public_path__ + "static/media/icon.ba34f631.png";